import { useReactivateContract } from '@/hooks/useWizard'
import { Check } from '@/icons'
import { Alert, Button, Flex } from '@chakra-ui/react'
import { useState } from 'react'

export const ReactivateContract = ({ insuranceId, callback }: { insuranceId: number, callback: () => void }) => {
  const [error, setError] = useState<string | null>(null)
  const { mutateAsync: reactivateContract, isLoading: isReactivating } = useReactivateContract()
  const handleReactivateContract = () => 
    reactivateContract(insuranceId)
      .then(() => {
        callback()
        setError(null)
      })
      .catch(() => {
        setError('Při reaktivaci došlo k chybě')
      })
      
  return  <Flex flexDir='column' gap={4} mx={4} w={'full'}>
    <Button
      variant="outline"
      colorScheme="green"
      onClick={handleReactivateContract}
      disabled={isReactivating}
      py={1}
      w={'full'}
    >
      <Check />
      {isReactivating ? 'Reaktivuji...' : 'Reaktivovat smlouvu'}
    </Button>
      
    {error && <Alert colorScheme="red">{error}</Alert>}
  </Flex>
}